import { render, staticRenderFns } from "./xibaoyichuan.vue?vue&type=template&id=769a3879&scoped=true&"
import script from "./xibaoyichuan.vue?vue&type=script&lang=js&"
export * from "./xibaoyichuan.vue?vue&type=script&lang=js&"
import style0 from "./xibaoyichuan.vue?vue&type=style&index=0&id=769a3879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a3879",
  null
  
)

export default component.exports